import { Navigate, useRoutes } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
// auth
import AuthGuard from '../auth/AuthGuard';
import GuestGuard from '../auth/GuestGuard';
// layouts
import CompactLayout from '../layouts/compact';
import DashboardLayout from '../layouts/dashboard';
// import MainLayout from '../layouts/main';
import SimpleLayout from '../layouts/simple';
// auth
// config
import { PATH_AFTER_LOGIN_ADMIN } from '../config-global';
//
import {
  AboutPage,
  BidBriefListPage,
  CaseStudiesPage,
  CaseStudiesReportPage,
  ChatPage,
  ComingSoonPage,
  //
  ComponentsOverviewPage,
  ConferenceEventManagementForm,
  // Conference Management
  ConferenceEventManagementIndexPage,
  Contact,
  ConventionandExhibitionApplicationForm,
  //
  DemoAnimatePage,
  DemoCarouselsPage,
  DemoChartsPage,
  DemoCopyToClipboardPage,
  DemoEditorPage,
  DemoFormValidationPage,
  DemoImagePage,
  DemoLabelPage,
  DemoLightboxPage,
  DemoMapPage,
  DemoMarkdownPage,
  DemoMegaMenuPage,
  DemoMultiLanguagePage,
  DemoNavigationBarPage,
  DemoOrganizationalChartPage,
  DemoScrollbarPage,
  DemoSnackbarPage,
  DemoTextMaxLinePage,
  DemoUploadPage,
  EconomicImpactIndexPage,
  EventApplicationPage,
  EventDetail,
  EventFormPage,
  EventInProcessList,
  EventLegacyPage,
  EventListPage,
  EventOrganizer,
  EventRegisterForm,
  FaqsPage,
  FoundationColorsPage,
  FoundationGridPage,
  FoundationIconsPage,
  FoundationShadowsPage,
  FoundationTypographyPage,
  // EventFormViewPage,
  // Dashboard: General
  GeneralAppPage,
  // Inventory Management
  JournalManagementIndexPage,
  KFADashboardPage,
  KFAReportPage,
  LegacyAwardPage,
  LegacyEventsPage,
  LegacyImpactDashboardPage,
  LegacyImpactPage,
  LegacyReportForm,
  LegacyTrainingPage,
  // Auth
  LoginPage,
  MainDashboard,
  MaintenancePage,
  MEIDTDashboard,
  MEITDSkillsGapDashboard,
  MEITDTalentAnalyticsDashboard,
  TalentIntelligencePage,
  TalentSectorPage,
  TalentForecastPage,
  PCDSImpactPage,
  TalentIntelligenceForecastPage,
  PredictionPage,
  AILabourPrediction,
  MEITDAIAssistantPage,
  //
  MUIAccordionPage,
  MUIAlertPage,
  MUIAutocompletePage,
  MUIAvatarPage,
  MUIBadgePage,
  MUIBreadcrumbsPage,
  MUIButtonsPage,
  MUICheckboxPage,
  MUIChipPage,
  MUIDataGridPage,
  MUIDialogPage,
  MUIListPage,
  MUIMenuPage,
  MUIPaginationPage,
  MUIPickersPage,
  MUIPopoverPage,
  MUIProgressPage,
  MUIRadioButtonsPage,
  MUIRatingPage,
  MUISliderPage,
  MUIStepperPage,
  MUISwitchPage,
  MUITablePage,
  MUITabsPage,
  MUITextFieldPage,
  MUITimelinePage,
  MUITooltipPage,
  MUITransferListPage,
  MUITreesViewPage,
  NewPasswordPage,
  OrganizerCaseStudiesPage,
  OrganizerDashboard,
  OrganizerKFADashboardPage,
  OrganizerLegacyEventsPage,
  OrganizerUNSDGDashboardPage,
  //
  OverallEventsPage,
  Page403,
  Page404,
  //
  Page500,
  PaymentPage,
  PDFDetail,
  PreForm,
  QuestionnairePage1,
  QuestionnairePage2,
  QuestionnairePage3,
  QuestionnairePage4,
  QuestionnairePage5,
  QuestionnairePage6,
  RegisterPage,
  ResetPasswordPage,
  SettingManagement,
  SurveyForm,
  SurveyManagementIndexPage,
  UNSDGDashboardPage,
  UNSDGReportPage,
  UploadData,
  UserAccountPage,
  UserCreatePage,
  UserEditPage,
  // Dashboard: User
  UserListPage,
  UserProfilePage,
  VendorPostEventForm,
  VendorPreEventForm,
  VerifyCodePage
} from './elements';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    // // Auth
    {
      path: '',
      children: [
        {
          path: '',
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
        },
        {
          path: 'register',
          element: (
            <GuestGuard>
              <RegisterPage />
            </GuestGuard>
          ),
        },
        {
          path: 'login-unprotected',
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
        },
        { path: 'register-unprotected', element: <RegisterPage /> },

        {
          element: <CompactLayout />,
          children: [
            { path: 'reset-password', element: <ResetPasswordPage /> },
            { path: 'new-password', element: <NewPasswordPage /> },
            { path: 'verify', element: <VerifyCodePage /> },
          ],
        },
      ],
    },

    // Dashboard
    {
      path: 'dashboard',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        {
          element: (
            <Navigate to={PATH_AFTER_LOGIN_ADMIN} replace />
          ),
          index: true,
        },
        { path: 'app', element: <GeneralAppPage /> },

        { path: 'maindashboard', element: <MainDashboard /> },
        { path: 'meitd-dashboard', element: <MEIDTDashboard /> },
        { path: 'talent-analytics', element: <MEITDTalentAnalyticsDashboard /> },
        { path: 'talent-intelligence', element: <TalentIntelligencePage /> },
        { path: 'talent-intelligence-forecast', element: <TalentIntelligenceForecastPage /> },
        { path: 'prediction', element: <PredictionPage /> },
        { path: 'talent-sector', element: <TalentSectorPage /> },
        { path: 'talent-forecast', element: <TalentForecastPage /> },
        { path: 'pcds-2030', element: <PCDSImpactPage /> },
        { path: 'skills-gap', element: <MEITDSkillsGapDashboard /> },
        { path: 'ai-labour-prediction', element: <AILabourPrediction /> },
        { path: 'meitd-ai-assistant', element: <MEITDAIAssistantPage /> },
        { path: 'PDFDetail', element: <PDFDetail /> },

        { path: 'events', element: <EventListPage /> },

        { path: 'event/:selectedID', element: <EventDetail /> },
        { path: 'legacyImpactDashboard', element: <LegacyImpactDashboardPage /> },
        { path: 'kfa-dashboard', element: <KFADashboardPage /> },
        { path: 'unsdg-dashboard', element: <UNSDGDashboardPage /> },

        { path: 'kfa-report', element: <KFAReportPage /> },
        { path: 'unsdg-report', element: <UNSDGReportPage /> },
        { path: 'event-report', element: <CaseStudiesReportPage /> },

        { path: 'eventForm', element: <EventFormPage /> },
        { path: 'profile', element: <UserProfilePage /> },
        { path: 'legacyImpact', element: <LegacyImpactPage /> },

        { path: 'vendorpreconventionform/:eventid/:year', element: <VendorPreEventForm /> },
        { path: 'vendorpostconventionform/:eventid/:year', element: <VendorPostEventForm /> },

        { path: 'overall', element: <OverallEventsPage /> },
        { path: 'legacy-events', element: <LegacyEventsPage /> },
        { path: 'case-studies', element: <CaseStudiesPage /> },
        { path: 'eventInProcess', element: <EventInProcessList /> },
        { path: 'eventOrganizer', element: <EventOrganizer /> },
        { path: 'organizationDashboard', element: <OrganizerDashboard /> },
        { path: 'OrganizerKFADashboardPage', element: <OrganizerKFADashboardPage /> },

        { path: 'OrganizerUNSDGDashboardPage', element: <OrganizerUNSDGDashboardPage /> },
        { path: 'OrganizerCaseStudiesPage', element: <OrganizerCaseStudiesPage /> },
        { path: 'OrganizerLegacyEventsPage', element: <OrganizerLegacyEventsPage /> },




        { path: 'EventApplicationPage', element: <EventApplicationPage /> },

        {
          path: 'conference-event-management',
          children: [
            {
              element: <Navigate to="/conference-event-management/conference-event" replace />,
              index: true,
            },
            { path: 'conference-event', element: <ConferenceEventManagementIndexPage /> },
            { path: 'form', element: <ConferenceEventManagementForm /> },
          ],
        },
        { path: 'event-management', element: <EventLegacyPage /> },
        {
          path: 'convention-and-exhibition-application-form/:selectedID',
          element: <ConventionandExhibitionApplicationForm />,
        },
        { path: 'Pre-form/:selectedID', element: <PreForm /> },
        { path: 'event-register-form', element: <EventRegisterForm /> },
        { path: 'QuestionnairePage1', element: <QuestionnairePage1 /> },
        { path: 'QuestionnairePage2', element: <QuestionnairePage2 /> },
        { path: 'QuestionnairePage3', element: <QuestionnairePage3 /> },
        { path: 'QuestionnairePage4', element: <QuestionnairePage4 /> },
        { path: 'QuestionnairePage5', element: <QuestionnairePage5 /> },
        { path: 'QuestionnairePage6', element: <QuestionnairePage6 /> },
        { path: 'event-report-form', element: <LegacyReportForm /> },
        { path: 'upload-data', element: <UploadData /> },
        { path: 'legacy-training', element: <LegacyTrainingPage /> },
        { path: 'legacy-Award', element: <LegacyAwardPage /> },
        { path: 'economic-impact-index', element: <EconomicImpactIndexPage /> },

        {
          path: 'user',
          children: [
            { path: 'list', element: <UserListPage /> },
            { path: 'new', element: <UserCreatePage /> },
            { path: ':name/edit', element: <UserEditPage /> },
            { path: 'account', element: <UserAccountPage /> },
          ],
        },
        {
          path: 'bidBrief',
          children: [{ path: 'list', element: <BidBriefListPage /> }],
        },

        {
          path: 'chat/:conversationKey',
          element: <ChatPage />,
        },
        {
          path: 'chat',
          element: <Navigate to={`/dashboard/chat/${uuidv4()}`} replace />,
        },
      ],
    },

    {
      path: 'conference', // the main path to the journal management, type /DJMS will redirect to the index page
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <ConferenceEventManagementIndexPage />, index: true },
        {
          path: 'conference-event-management',
          children: [
            {
              element: (
                <Navigate to="/conference/conference-event-management/conference-event" replace />
              ),
              index: true,
            },
            { path: 'conference-event', element: <ConferenceEventManagementIndexPage /> },
            { path: 'form', element: <ConferenceEventManagementForm /> },
          ],
        },
        {
          path: 'journal-management',
          children: [
            {
              element: <Navigate to="/conference/journal-management/journal" replace />,
              index: true,
            },
            { path: 'journal', element: <JournalManagementIndexPage /> },
          ],
        },
        {
          path: 'survey-management',
          children: [
            {
              element: <Navigate to="/conference/survey-management/survey" replace />,
              index: true,
            },
            { path: 'survey', element: <SurveyManagementIndexPage /> },
            { path: 'form', element: <SurveyForm /> },
          ],
        },
        {
          path: 'settings',
          children: [
            {
              element: <Navigate to="/conference/settings/general-setting" replace />,
              index: true,
            },
            { path: 'general-setting', element: <SettingManagement /> },
            // { path: 'form', element: <EventManagementForm /> },
          ],
        },
      ],
    },

    // Main Routes
    {
      path: 'landing',
      // element: <MainLayout />,
      children: [
        { path: 'about-us', element: <AboutPage /> },
        { path: 'contact-us', element: <Contact /> },
        { path: 'faqs', element: <FaqsPage /> },
        // Demo Components
        {
          path: 'components',
          children: [
            { element: <ComponentsOverviewPage />, index: true },
            {
              path: 'foundation',
              children: [
                { element: <Navigate to="/components/foundation/colors" replace />, index: true },
                { path: 'colors', element: <FoundationColorsPage /> },
                { path: 'typography', element: <FoundationTypographyPage /> },
                { path: 'shadows', element: <FoundationShadowsPage /> },
                { path: 'grid', element: <FoundationGridPage /> },
                { path: 'icons', element: <FoundationIconsPage /> },
              ],
            },
            {
              path: 'mui',
              children: [
                { element: <Navigate to="/components/mui/accordion" replace />, index: true },
                { path: 'accordion', element: <MUIAccordionPage /> },
                { path: 'alert', element: <MUIAlertPage /> },
                { path: 'autocomplete', element: <MUIAutocompletePage /> },
                { path: 'avatar', element: <MUIAvatarPage /> },
                { path: 'badge', element: <MUIBadgePage /> },
                { path: 'breadcrumbs', element: <MUIBreadcrumbsPage /> },
                { path: 'buttons', element: <MUIButtonsPage /> },
                { path: 'checkbox', element: <MUICheckboxPage /> },
                { path: 'chip', element: <MUIChipPage /> },
                { path: 'data-grid', element: <MUIDataGridPage /> },
                { path: 'dialog', element: <MUIDialogPage /> },
                { path: 'list', element: <MUIListPage /> },
                { path: 'menu', element: <MUIMenuPage /> },
                { path: 'pagination', element: <MUIPaginationPage /> },
                { path: 'pickers', element: <MUIPickersPage /> },
                { path: 'popover', element: <MUIPopoverPage /> },
                { path: 'progress', element: <MUIProgressPage /> },
                { path: 'radio-button', element: <MUIRadioButtonsPage /> },
                { path: 'rating', element: <MUIRatingPage /> },
                { path: 'slider', element: <MUISliderPage /> },
                { path: 'stepper', element: <MUIStepperPage /> },
                { path: 'switch', element: <MUISwitchPage /> },
                { path: 'table', element: <MUITablePage /> },
                { path: 'tabs', element: <MUITabsPage /> },
                { path: 'textfield', element: <MUITextFieldPage /> },
                { path: 'timeline', element: <MUITimelinePage /> },
                { path: 'tooltip', element: <MUITooltipPage /> },
                { path: 'transfer-list', element: <MUITransferListPage /> },
                { path: 'tree-view', element: <MUITreesViewPage /> },
              ],
            },
            {
              path: 'extra',
              children: [
                { element: <Navigate to="/components/extra/animate" replace />, index: true },
                { path: 'animate', element: <DemoAnimatePage /> },
                { path: 'carousel', element: <DemoCarouselsPage /> },
                { path: 'chart', element: <DemoChartsPage /> },
                { path: 'copy-to-clipboard', element: <DemoCopyToClipboardPage /> },
                { path: 'editor', element: <DemoEditorPage /> },
                { path: 'form-validation', element: <DemoFormValidationPage /> },
                { path: 'image', element: <DemoImagePage /> },
                { path: 'label', element: <DemoLabelPage /> },
                { path: 'lightbox', element: <DemoLightboxPage /> },
                { path: 'map', element: <DemoMapPage /> },
                { path: 'mega-menu', element: <DemoMegaMenuPage /> },
                { path: 'multi-language', element: <DemoMultiLanguagePage /> },
                { path: 'navigation-bar', element: <DemoNavigationBarPage /> },
                { path: 'organization-chart', element: <DemoOrganizationalChartPage /> },
                { path: 'scroll', element: <DemoScrollbarPage /> },
                { path: 'snackbar', element: <DemoSnackbarPage /> },
                { path: 'text-max-line', element: <DemoTextMaxLinePage /> },
                { path: 'upload', element: <DemoUploadPage /> },
                { path: 'markdown', element: <DemoMarkdownPage /> },
              ],
            },
          ],
        },
      ],
    },
    {
      element: <SimpleLayout />,
      children: [{ path: 'payment', element: <PaymentPage /> }],
    },
    {
      element: <CompactLayout />,
      children: [
        { path: 'coming-soon', element: <ComingSoonPage /> },
        { path: 'maintenance', element: <MaintenancePage /> },
        { path: '500', element: <Page500 /> },
        { path: '404', element: <Page404 /> },
        { path: '403', element: <Page403 /> },
      ],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
    { path: 'chat', element: <ChatPage /> }
  ]);
}
